import React from 'react';
import { Box, Typography, Button, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import useStyles from "../../../assets/styles/HomeStyles";
import {useHistory} from "react-router-dom";

const DQProOnboardingWhatCanYouEarn = () => {
    const classes = useStyles();
    const history = useHistory();

    const tableData = [
        { tier: '0–1,000', suggested: '$10', yourCost: '$5.00', revenue: '$5.00' },
        { tier: '1,001–5,000', suggested: '$10', yourCost: '$4.00', revenue: '$6.00' },
        { tier: '5,001–10,000', suggested: '$10', yourCost: '$3.50', revenue: '$6.50' },
        { tier: '10,001–50,000', suggested: '$10', yourCost: '$3.00', revenue: '$7.00' },
        { tier: '50,001–100,000', suggested: '$10', yourCost: '$2.50', revenue: '$7.50' }
    ];

    return (
        <Box className={classes.pageContainer} style={{marginTop:'auto'}}>
            <Typography variant="h3" className={classes.title} sx={{ mb: 6, textAlign: 'center' }}>
                What Can You Earn
            </Typography>

            <Grid container spacing={5} gap={6} alignItems="center" justifyContent="center" marginTop="auto">
                {/* Left Column - Table */}
                <Grid item xs={12} md={5} >
                    <TableContainer component={Paper} elevation={3}>
                        <Table>
                            <TableHead>
                                <TableRow sx={{ backgroundColor: '#000000 !important', color:'#ffffff !important' }}>
                                    <TableCell sx={{ fontSize:'16px',fontWeight: 'bold',textAlign:'center', color:'#ffffff !important' }}>Tiers Based on # of Licenses</TableCell>
                                    <TableCell sx={{ fontSize:'16px',fontWeight: 'bold',textAlign:'center', color:'#ffffff !important' }}>Suggested Retail Cost Per License</TableCell>
                                    <TableCell sx={{ fontSize:'16px',fontWeight: 'bold',textAlign:'center', color:'#ffffff !important' }}>Your Cost Per License*</TableCell>
                                    <TableCell sx={{ fontSize:'16px',fontWeight: 'bold',textAlign:'center', color:'#ffffff !important' }}>Your Potential Revenue Based on Retail Cost</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tableData.map((row, index) => (
                                    <TableRow key={index}>
                                        <TableCell sx={{fontSize:'17px',textAlign:'center', }}>{row.tier}</TableCell>
                                        <TableCell sx={{fontSize:'17px',textAlign:'center', }}>{row.suggested}</TableCell>
                                        <TableCell sx={{fontSize:'17px',textAlign:'center', }}>{row.yourCost}</TableCell>
                                        <TableCell sx={{fontSize:'17px',textAlign:'center', }}>{row.revenue}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>

                <Grid item xs={12} md={4}>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%',
                        justifyContent: 'center',
                        p: 2
                    }}>
                        <Typography variant="h4" sx={{
                            color: '#ff6468',
                            fontWeight: 'bold',
                            lineHeight:'1.1',
                            mb: 3,
                            textAlign: 'left'
                        }}>
                            As a <b>DQ</b>pro, you have the freedom to set your own selling price and maximize your earning potential.
                        </Typography>

                        <Typography variant="body1" paragraph sx={{fontSize:'22px', lineHeight:'1.1', mb: 3 }}>
                            Each license comes with a low, fixed base cost (Your Cost Per License) giving you full control over your margins.
                        </Typography>

                        <Typography variant="body1" paragraph sx={{fontSize:'22px', lineHeight:'1.1', mb: 4 }}>
                            At the end of each month, you'll simply be invoiced for the number of licenses your clients have used.
                        </Typography>

                        <Box style={{display:'flex', alignItems:'center', justifyContent:'center'}}>
                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: '#0097b2',
                                width: '80%',
                                fontWeight: 'bold',
                                fontSize: '18px',
                                borderRadius: '20px',
                                '&:hover': {
                                    backgroundColor: '#0097b2',
                                    color:'#ffffff'
                                }
                            }}
                            onClick={()=>{history.push('/dq_pro/onboarded/rewards')}}
                        >
                            Check Out Our <b>DQ</b>pro Rewards
                        </Button>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default DQProOnboardingWhatCanYouEarn;